import type { MidiNote } from "../types";
import type { DrumVoice } from "./drum-synth";

export type DrumRow = "kick" | "snare" | "hiHat" | "ride" | "crash" | "rackTom" | "floorTom";

export const drumRows: ReadonlyArray<{
  id: DrumRow;
  label: string;
  pitches: ReadonlySet<number>;
  voice: DrumVoice;
}> = [
  { id: "kick", label: "Kick", pitches: new Set([35, 36]), voice: "kick" },
  { id: "snare", label: "Snare", pitches: new Set([37, 38, 39, 40]), voice: "snare" },
  { id: "hiHat", label: "Hi-hat", pitches: new Set([42, 44, 46]), voice: "hat" },
  { id: "ride", label: "Ride", pitches: new Set([51, 53, 59]), voice: "ride" },
  { id: "crash", label: "Crash", pitches: new Set([49, 52, 55, 57]), voice: "crash" },
  { id: "rackTom", label: "Rack toms", pitches: new Set([45, 47, 48, 50]), voice: "rackTom" },
  { id: "floorTom", label: "Floor tom", pitches: new Set([41, 43]), voice: "floorTom" },
];

const rowsById = new Map(drumRows.map((row) => [row.id, row]));

export const rowForDrumNote = (note: MidiNote): DrumRow => {
  if (note.voice && rowsById.has(note.voice)) return note.voice;
  const row = drumRows.find((candidate) => candidate.pitches.has(note.pitch));
  if (!row) throw new Error(`Unsupported General MIDI drum pitch: ${note.pitch}`);
  return row.id;
};

export const enabledDrumRows = (): Record<DrumRow, boolean> => ({
  kick: true,
  snare: true,
  hiHat: true,
  ride: true,
  crash: true,
  rackTom: true,
  floorTom: true,
});
